import React from "react";
import Layout from "../../../components/layout/layout.js";
import { Headshots } from "../../../components/headshots/headshots.js";

export default function HeadshotsPage({ component, ...rest }) {
  return <Layout Component={Headshots} {...rest} controlsDisabled />;
}

